import React from 'react';
import { motion } from 'framer-motion';
import { Search, ChevronDown } from 'lucide-react';
export function IPhoneMockup() {
  return <motion.div initial={{
    y: 20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="relative mx-auto w-[300px] h-[600px] bg-[#1C1C1E] rounded-[55px] p-3 shadow-2xl border-[6px] border-[#3a3a3c]" style={{
    boxShadow: '0 0 0 2px #535353, 0 25px 50px -12px rgba(0, 0, 0, 0.5)'
  }} data-id="element-60">
      {/* Dynamic Island / Notch */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[100px] h-[28px] bg-black rounded-b-[18px] z-20 mt-3" data-id="element-61"></div>

      {/* Side Buttons */}
      <div className="absolute top-[100px] -left-[8px] w-[4px] h-[30px] bg-[#2a2a2b] rounded-l-md" data-id="element-62"></div>
      <div className="absolute top-[140px] -left-[8px] w-[4px] h-[50px] bg-[#2a2a2b] rounded-l-md" data-id="element-63"></div>
      <div className="absolute top-[120px] -right-[8px] w-[4px] h-[80px] bg-[#2a2a2b] rounded-r-md" data-id="element-64"></div>

      {/* Screen Content */}
      <div className="relative w-full h-full bg-white rounded-[45px] overflow-hidden flex flex-col" data-id="element-65">
        {/* Status Bar Placeholder */}
        <div className="h-12 w-full bg-[#0F1B2D] z-10" data-id="element-66"></div>

        {/* Mini Navbar */}
        <div className="flex items-center justify-between px-4 py-3 bg-white border-b border-slate-100" data-id="element-67">
          <div className="flex items-center gap-1" data-id="element-68">
            <div className="h-5 w-5 bg-[#0F1B2D] rounded-sm flex items-center justify-center" data-id="element-69">
              <div className="w-1.5 h-1.5 bg-white grid grid-cols-2 gap-[1px]" data-id="element-70">
                <div className="bg-white" data-id="element-71"></div>
                <div className="bg-white" data-id="element-72"></div>
                <div className="bg-white" data-id="element-73"></div>
                <div className="bg-white" data-id="element-74"></div>
              </div>
            </div>
            <span className="text-[#0F1B2D] font-bold text-xs" data-id="element-75">VeriProp</span>
          </div>
          <div className="h-6 px-3 bg-[#E8531E] rounded text-[10px] font-medium text-white flex items-center" data-id="element-76">
            Sign In
          </div>
        </div>

        {/* Hero Section */}
        <div className="relative flex-1 bg-[#0F1B2D] overflow-hidden flex flex-col items-center justify-center px-4 text-center" data-id="element-77">
          {/* Background Image Placeholder */}
          <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1600596542815-2495db98dada?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')] bg-cover bg-center" data-id="element-78"></div>

          <div className="relative z-10 mt-4" data-id="element-79">
            <h1 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-80">
              Your Trusted Bridge to Property Ownership in Nigeria
            </h1>
            <p className="text-[10px] text-slate-300 mb-4 leading-relaxed max-w-[200px] mx-auto" data-id="element-81">
              Secure, transparent, and hassle-free real estate solutions for
              Nigerians in the diaspora.
            </p>

            <div className="flex gap-2 justify-center mb-6" data-id="element-82">
              <div className="px-3 py-1.5 bg-white text-[#0F1B2D] text-[10px] font-bold rounded" data-id="element-83">
                Browse Properties
              </div>
              <div className="px-3 py-1.5 border border-white text-white text-[10px] font-bold rounded" data-id="element-84">
                Sign Up Now
              </div>
            </div>

            {/* Search Bar */}
            <div className="bg-white rounded-lg p-2 w-full shadow-lg" data-id="element-85">
              <div className="grid grid-cols-3 gap-1 mb-2" data-id="element-86">
                <div className="bg-slate-50 rounded p-1 flex items-center justify-between" data-id="element-87">
                  <span className="text-[8px] text-slate-500" data-id="element-88">Location</span>
                  <ChevronDown className="h-2 w-2 text-slate-400" data-id="element-89" />
                </div>
                <div className="bg-slate-50 rounded p-1 flex items-center justify-between" data-id="element-90">
                  <span className="text-[8px] text-slate-500" data-id="element-91">Type</span>
                  <ChevronDown className="h-2 w-2 text-slate-400" data-id="element-92" />
                </div>
                <div className="bg-slate-50 rounded p-1 flex items-center justify-between" data-id="element-93">
                  <span className="text-[8px] text-slate-500" data-id="element-94">Price</span>
                  <ChevronDown className="h-2 w-2 text-slate-400" data-id="element-95" />
                </div>
              </div>
              <div className="w-full bg-[#E8531E] h-7 rounded flex items-center justify-center gap-1 text-white" data-id="element-96">
                <Search className="h-3 w-3" data-id="element-97" />
                <span className="text-[10px] font-bold" data-id="element-98">Search</span>
              </div>
            </div>
          </div>
        </div>

        {/* How It Works Header */}
        <div className="bg-white py-4 px-4 text-center" data-id="element-99">
          <h2 className="text-[#0F1B2D] font-bold text-sm" data-id="element-100">
            How VeriProp Works
          </h2>
          <div className="w-8 h-0.5 bg-[#E8531E] mx-auto mt-1" data-id="element-101"></div>
        </div>

        {/* Screen Glare Reflection */}
        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent pointer-events-none rounded-[45px]" data-id="element-102"></div>
      </div>
    </motion.div>;
}